import {useEffect, useState} from 'react';
import {extension} from '../utils';

export const useBrowserExtension = () => {
  const [isReady, setIsReady] = useState(false);
  const [extensionVersion, setExtensionVersion] = useState<string | null>(null);
  const [isExtensionAuthenticated, setIsExtensionAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    Promise.all([
      extension.getExtensionVersion().then(setExtensionVersion),
      extension.getIsExtensionAuthenticated().then(setIsExtensionAuthenticated),
    ]).finally(() => setIsReady(true));
  }, []);

  return {
    isReady,
    hasExtension: !!extensionVersion,
    extensionVersion,
    isExtensionAuthenticated,
  };
};
